<portal-main-nav>
  <!-- Enterprises -->
  <portal-main-nav-item icon="far fa-industry" route="service-provider-enterprises">
    <span>{{ 'menu.enterprises' | portalTranslate }}</span>
  </portal-main-nav-item>

  <!-- Administrators -->
  <portal-main-nav-item
    *portalIsAuthorized="{
      anyPermission: [Permission.VIEW_ADMINS],
    }"
    icon="far fa-user"
    route="service-provider-administrator"
  >
    <span>{{ 'menu.admins' | portalTranslate }}</span>
  </portal-main-nav-item>

  <!-- Registrations -->
  <portal-main-nav-item
    *portalIsAuthorized="{
      anyPermission: [Permission.VIEW_ANY_REGISTRATIONS],
    }"
    icon="far fa-compress"
    route="service-provider-registration-summary"
  >
    <span>{{ 'menu.registrations' | portalTranslate }}</span>
  </portal-main-nav-item>

  <!-- Call barring -->
  <portal-main-nav-item icon="far fa-shield" route="service-provider-call-barring">
    <span>{{ 'menu.callBarring' | portalTranslate }}</span>
  </portal-main-nav-item>

  <!-- IP filter -->
  <portal-main-nav-item icon="far fa-network-wired" route="service-provider-ipfilter">
    <span>{{ 'menu.ipFilter' | portalTranslate }}</span>
  </portal-main-nav-item>

  <!-- Allowed devices -->
  <portal-main-nav-item
    *portalIsAuthorized="{
      anyPermission: [Permission.VIEW_ALLOWED_DEVICES],
    }"
    icon="far fa-phone-office"
    route="service-provider-allowed-devices"
  >
    <span>{{ 'menu.allowedDevices' | portalTranslate }}</span>
  </portal-main-nav-item>

  <!-- Device attributes -->
  <portal-main-nav-item icon="far fa-tablet" route="service-provider-device-attributes">
    <span>{{ 'menu.deviceAttributes' | portalTranslate }}</span>
  </portal-main-nav-item>

  <!-- Notifications -->
  <portal-main-nav-item
    *portalIsAuthorized="{ allPermissions: [SecurityPermissionName.VIEW_NOTIFICATIONS] }"
    icon="far fa-bullhorn"
    route="service-provider-notifications"
  >
    <span>{{ 'menu.notifications' | portalTranslate }}</span>
  </portal-main-nav-item>

  <!-- Product options -->
  <portal-main-nav-item
    *portalIsAuthorized="{
      anyPermission: [Permission.VIEW_PRODUCT_OPTION],
    }"
    icon="far fa-gift"
    route="service-provider-product-options"
  >
    <span>{{ 'menu.productOptions' | portalTranslate }}</span>
  </portal-main-nav-item>

  <!-- *portalIsAuthorized="{
    anyPermission: []
  }" -->
  <portal-main-nav-item icon="far fa-list" route="service-provider-feature-profiles">
    <span>{{ 'menu.featureProfiles' | portalTranslate }}</span>
  </portal-main-nav-item>

  <!-- Roles -->
  <portal-main-nav-item icon="far fa-id-card" route="service-provider-roles">
    <span>{{ 'menu.roles' | portalTranslate }}</span>
  </portal-main-nav-item>

  <!-- Journal -->
  <portal-main-nav-item icon="far fa-history" route="service-provider-journal-history">
    <span>{{ 'menu.journal' | portalTranslate }}</span>
  </portal-main-nav-item>

  <!-- Call details -->
  <portal-main-nav-item
    *portalIsAuthorized="{
      anyPermission: [Permission.VIEW_CDR],
    }"
    icon="far fa-phone"
    route="service-provider-journal-call-details"
  >
    <span>{{ 'menu.cdr' | portalTranslate }}</span>
  </portal-main-nav-item>

  <!-- Files -->
  <portal-main-nav-item icon="far fa-file" route="service-provider-files">
    <span>{{ 'menu.files' | translate }}</span>
  </portal-main-nav-item>

  <!-- Soft clients -->
  <portal-main-nav-item icon="far fa-download" route="service-provider-soft-clients">
    <span>{{ 'menu.softClients' | portalTranslate }}</span>
  </portal-main-nav-item>

  <!-- Documents -->
  <portal-main-nav-item icon="far fa-book" route="service-provider-documentation">
    <span>{{ 'menu.documentation' | portalTranslate }}</span>
  </portal-main-nav-item>
</portal-main-nav>
